import { useContextStore } from "@/store/context";

export const lazyComponents = import.meta.glob(["@/components/**/default.vue", "@/components/**/mobile.vue", "@/components/**/index.vue"])

export const defineLazyComponent = (loader) => {
  return defineAsyncComponent({
    loader,
    suspensible: false
  });
}

export const defineLazyAdaptiveComponent = (path) => {
  const { layout } = useContextStore();
  return defineAsyncComponent({
    loader:
      lazyComponents[
      `${path}/${layout}.vue`
      ],
    suspensible: false
  });
}